module.exports = __webpack_public_path__ + "static/studentaccom-c95bd75a0c57de016d6b1a7510014634.jpg";